import {
  Modal,
  ModalContent,
  type ModalHook,
  useControlledModalState,
} from '@leland-dev/leland-ui-library';
import React, { type FC } from 'react';

import YouTubeEmbed from '../../common/YouTubeEmbed';

interface IntroVideoModalHookProps {
  youtubeId: string;
}

interface IntroVideoModalProps extends IntroVideoModalHookProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const IntroVideoModalContent: FC<IntroVideoModalProps> = ({
  open,
  setOpen,
  youtubeId,
}) => {
  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalContent preventScroll>
        <YouTubeEmbed
          className="size-full min-h-[468px] bg-black md:min-w-[672px]"
          youtubeId={youtubeId}
        />
      </ModalContent>
    </Modal>
  );
};

export const useIntroVideoModal: ModalHook<IntroVideoModalHookProps> = () => {
  const [open, setOpen] = useControlledModalState();
  const IntroVideoModal: FC<IntroVideoModalHookProps> = (props) => {
    return open ? (
      <IntroVideoModalContent {...props} open={open} setOpen={setOpen} />
    ) : null;
  };
  return { open, setOpen, Modal: IntroVideoModal };
};
